import React from "react";

const NewsSkeleton: React.FC = () => {
  return (
    <div className="rounded-xl h-1/2 bg-content3 flex flex-col overflow-y-auto shadow-inner">
      {[...Array(3)].map((_, index) => (
        <div key={index} className="border-b-textsecondary border-b-[1px] p-4 flex flex-row justify-between">
          <div className="w-full">
            <div className="h-6 bg-content2 rounded w-3/4 mb-4 animate-pulse"></div>
            <div className="space-y-2">
              <div className="h-4 bg-content2 rounded w-full animate-pulse"></div>
              <div className="h-4 bg-content2 rounded w-5/6 animate-pulse"></div>
              <div className="h-4 bg-content2 rounded w-2/3 animate-pulse"></div>
            </div>
          </div>
          <div>
            <div className="rounded-full bg-content2 p-3 h-12 w-24 animate-pulse"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NewsSkeleton;